//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import ToxicChemicalDrawer from "./modules/ToxicChemicalDrawer";
import { getAction } from '@/api/manage';
export default {
  name: 'ToxicChemical',
  mixins: [JeecgListMixin],
  components: {
    ToxicChemicalDrawer: ToxicChemicalDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/toxic/chemical',
      pageTitle: '易制毒化学品管理',
      addDisabled: false,
      userTree: [],
      companyList: [],
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'prUserName',
        colName: 'pr_user_id',
        title: '采购申请人',
        align: 'center'
      }, {
        dataIndex: 'paUserName',
        colName: 'pa_user_id',
        title: '采购审批人',
        align: 'center'
      }, {
        dataIndex: 'approvalUserName',
        colName: 'approval_user_id',
        title: '审批人',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'company_id',
        title: '签订供应商',
        align: 'center'
      }, {
        dataIndex: 'agreementType_dictText',
        colName: 'agreement_type',
        title: '合同类型',
        align: 'center'
      }, {
        dataIndex: 'deliverStatus_dictText',
        colName: 'deliver_status',
        title: '是否送至储存库房',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryParamList();
  },
  methods: {
    queryParamList: function queryParamList() {
      var _this = this;

      var that = this;
      that.userTree = [];
      that.companyList = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
      getAction('/ea/company/info/queryCompanyName').then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};